import { Card as ReactStrapCard, CardBody } from 'reactstrap';
import cls from 'classnames';
import './Card.scss';

export const Card = ({ children, className = '' }) => (
    <ReactStrapCard
        color="light"
        className={cls(
            'reactstrap-card',
            className,
        )}
    >
        <CardBody>
            {children}
        </CardBody>
    </ReactStrapCard>
);